import React from 'react'
import PropTypes from 'prop-types'

export const WizardFooter = ({
  step,
  totalSteps,
  onCancel,
  onBack,
  onNext,
  onImport,
  canGoNext,
  showImportOnStep2,
  isImporting,
}) => {
  const showBack = step > 1
  const isLastStep = step === totalSteps
  const showImport = isLastStep || (step === 2 && showImportOnStep2)
  const showNext = !showImport || (step === 2 && !showImportOnStep2)

  return (
    <div className="courses-modal-buttons-container popup_action">
      <div className="pull-left">
        <button
          className="cancel_action small grey button btsp_small_white_button"
          onClick={onCancel}
        >
          {window.I18n.t('buttons.cancel')}
        </button>
      </div>
      <div>
        {showBack && (
          <button
            className="back_action small grey button btsp_small_white_button add-margin-right-5"
            onClick={onBack}
          >
            {window.I18n.t('buttons.back_capitalized')}
          </button>
        )}
        {showNext && (
          <button
            className="next_action small orange button btsp_small_orange_button"
            onClick={onNext}
            disabled={!canGoNext}
          >
            {window.I18n.t('buttons.next_capitalized')}
          </button>
        )}
        {showImport && (
          <button
            className="submit_action copy small orange button btsp_small_orange_button"
            onClick={onImport}
            disabled={!canGoNext || isImporting}
          >
            {isImporting ? window.I18n.t('buttons.importing') : window.I18n.t('buttons.import')}
          </button>
        )}
      </div>

    </div>
  )
}

WizardFooter.propTypes = {
  step: PropTypes.number.isRequired,
  totalSteps: PropTypes.number.isRequired,
  onCancel: PropTypes.func.isRequired,
  onBack: PropTypes.func.isRequired,
  onNext: PropTypes.func.isRequired,
  onImport: PropTypes.func.isRequired,
  canGoNext: PropTypes.bool.isRequired,
  showImportOnStep2: PropTypes.bool,
  isImporting: PropTypes.bool,
}

WizardFooter.defaultProps = {
  showImportOnStep2: false,
}
